var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7598_3489)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3994 1.56609C24.8446 -0.47308 21.5458 0.608568 21.5458 3.15751V5.71696C16.5162 5.65743 13.0756 7.38631 10.7838 9.80072C8.33382 12.3817 7.32614 15.6085 6.90387 17.8149C6.69275 18.918 7.41634 19.7184 8.17679 19.9948C8.90327 20.2588 9.87402 20.1457 10.5218 19.4052C12.3605 17.3036 15.9327 14.3704 21.5458 14.5619V17.8425C21.5458 20.3915 24.8446 21.4731 26.3994 19.4339L31.3911 12.8871C32.4696 11.4725 32.4696 9.52747 31.3911 8.11288L26.3994 1.56609ZM10.176 15.9793C12.583 13.8788 16.038 11.9076 21.5458 11.9076H22.8943C23.639 11.9076 24.2426 12.5014 24.2426 13.2338L24.2423 17.8425L29.2339 11.2957C29.5935 10.8242 29.5935 10.1758 29.2339 9.70429L24.2423 3.15751V7.04317C24.2423 7.7756 23.6387 8.36935 22.894 8.36935H21.5458C15.4791 8.36935 12.7546 11.6109 12.7546 11.6109C11.5004 12.9322 10.6932 14.5027 10.176 15.9793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5332 1.83838H5.5332C3.32407 1.83838 1.5332 3.62923 1.5332 5.83838V27.1717C1.5332 29.3809 3.32407 31.1717 5.5332 31.1717H26.8665C29.0757 31.1717 30.8665 29.3809 30.8665 27.1717V23.1717C30.8665 22.4353 30.2696 21.8384 29.5332 21.8384C28.7968 21.8384 28.1999 22.4353 28.1999 23.1717V27.1717C28.1999 27.9081 27.6029 28.505 26.8665 28.505H5.5332C4.79683 28.505 4.19987 27.9081 4.19987 27.1717V5.83838C4.19987 5.10199 4.79683 4.50505 5.5332 4.50505H9.5332C10.2696 4.50505 10.8665 3.90809 10.8665 3.17171C10.8665 2.43533 10.2696 1.83838 9.5332 1.83838Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7598_3489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.200195 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDashboard);
export default __webpack_public_path__ + "static/media/share-dashboard.c7e62a53c97baf7f5f69bdf2cd9d3096.svg";
export { ForwardRef as ReactComponent };